import { FC } from 'react';
import { Box } from '@chakra-ui/react';
import { Tier } from 'types/subscription.types';
import { useAppDispatch } from 'app/store';
import { subscriptionTierSelectionCancelledAction } from 'app/store/Mixpanel/slice';
import { OverlayDialog } from 'app/components/Dialogs';
import { SubscriptionTiersOverlay } from './components/SubscriptionTiersOverlay';

interface CreateSubscriptionOverlayProps {
  open: boolean;
  tiers: Tier[];
  onClose: () => void;
}

export const CreateSubscriptionOverlay: FC<CreateSubscriptionOverlayProps> = ({
  open,
  tiers,
  onClose,
}) => {
  const dispatch = useAppDispatch();

  return (
    <>
      {open && (
        <OverlayDialog
          onClose={() => {
            dispatch(subscriptionTierSelectionCancelledAction());
            onClose();
          }}
        >
          <Box display="flex" flexDirection="column">
            <SubscriptionTiersOverlay tiers={tiers} onClose={onClose} />
          </Box>
        </OverlayDialog>
      )}
    </>
  );
};
